// extracted by mini-css-extract-plugin
export default {"app":"_2NR9EVXs","brand":"_3sz4kqsJ"};